/* AVOREL cart enhancement — external asset for reliable execution */
(function(){
  if (window.__avEnhance) return; window.__avEnhance = true;
  var HEAD_ID = '15592693072196';

  function headerSectionId(){
    var el = document.querySelector('[id^="shopify-section-"][id*="header"]');
    return el ? el.id.replace('shopify-section-','') : null;
  }
  window.avAdd = function(variantId, opts){
    opts = opts || {};
    var sid = headerSectionId();
    return fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id: Number(variantId), quantity: 1})})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ return sid ? fetch('/?sections=' + encodeURIComponent(sid)).then(function(r){return r.json();}).catch(function(){return {};}) : {}; })
      .then(function(secJson){
        var sections = {}; if (sid && secJson && secJson[sid]) sections[sid] = secJson[sid];
        document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{resource:{}, sourceId:'avorel-enhance', data:{source:'avorel-enhance', itemCount:1, productId: opts.productId || '', sections: sections}}}));
        return true;
      });
  };
  function openDrawer(){
    var d = document.querySelector('cart-drawer-component'); if (!d) return;
    try { if (typeof d.open === 'function') d.open(); } catch(e){}
    setTimeout(function(){ var dlg = d.querySelector('dialog'); if (dlg && !dlg.open){ try { dlg.showModal(); } catch(e){} } }, 130);
  }
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-av-add]'); if (!btn) return;
    if (btn.dataset.avState) return;
    var label = btn.querySelector('[data-av-label]') || btn;
    var orig = label.textContent;
    btn.dataset.avState = 'busy'; btn.classList.add('is-busy'); label.textContent = 'Adding\u2026';
    window.avAdd(btn.getAttribute('data-variant-id'), {productId: btn.getAttribute('data-product-id')})
      .then(function(){ btn.dataset.avState = 'done'; btn.classList.remove('is-busy'); btn.classList.add('is-added'); label.textContent = 'Added'; btn.setAttribute('aria-disabled','true'); })
      .catch(function(){ btn.dataset.avState = ''; btn.classList.remove('is-busy'); label.textContent = orig; });
  });
  var lastSrc = null;
  document.addEventListener('click', function(e){
    if (!e.target.closest) return;
    if (e.target.closest('.sticky-add-to-cart__button')) lastSrc = 'sticky';
    else if (e.target.closest('product-form-component [type="submit"]')) lastSrc = 'main';
  }, true);
  document.addEventListener('cart:update', function(e){
    var d = (e.detail && e.detail.data) || {};
    if (d.source === 'product-form-component' && String(d.productId) === HEAD_ID){
      if (lastSrc === 'sticky'){ openDrawer(); }
      else { var w = document.querySelector('.av-addon-reveal'); if (w){ w.classList.add('is-revealed'); } }
      lastSrc = null;
    }
    setTimeout(function(){ if(typeof applyDismiss==='function') applyDismiss(); }, 60);
  });

  function applyDismiss(){
    try{
      if(localStorage.getItem('av_dismiss_addon')==='1'){ var a=document.querySelectorAll('.av-addon-reveal'); for(var i=0;i<a.length;i++) a[i].style.display='none'; }
      if(localStorage.getItem('av_dismiss_dreco')==='1'){ var b=document.querySelectorAll('.av-dreco'); for(var j=0;j<b.length;j++) b[j].style.display='none'; }
    }catch(e){}
  }
  document.addEventListener('click', function(e){
    if(!e.target.closest) return;
    var x=e.target.closest('[data-av-dismiss]'); if(!x) return;
    e.preventDefault(); e.stopPropagation();
    var dreco=x.closest('.av-dreco');
    if(dreco){ try{localStorage.setItem('av_dismiss_dreco','1');}catch(e2){} dreco.style.display='none'; return; }
    var wrap=x.closest('.av-addon-reveal') || x.closest('.av-addon');
    if(wrap){ try{localStorage.setItem('av_dismiss_addon','1');}catch(e3){} wrap.style.display='none'; }
  });
  if(document.readyState!=='loading') applyDismiss(); else document.addEventListener('DOMContentLoaded', applyDismiss);

})();